import { debounce } from 'throttle-debounce'

class ShopFilters {
  constructor(element) {
    this.container = element
    this.wrapper = this.container.closest('.filters-wrapper')
    this.groups = this.container.querySelectorAll('.shop-filters__group')
    this.form = this.container.querySelector('.shop-filters__inner')
    this.options = this.container.querySelectorAll('input')
    this.resetBtn = this.container.querySelector('.btn--cancel')
    this.path = this.container.dataset.path

    this.resetForm = this.resetForm.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleHistory = this.handleHistory.bind(this)

    if (this.form) {
      this.init()
    }

    if (this.groups) {
      this.initToggle()
    }
  }

  resetForm() {
    this.form.reset()
  }

  getCheckedStatus() {
    const urlParams = new URLSearchParams(window.location.search)

    const categories = urlParams.get('categorias')
    const brands = urlParams.get('marcas')

    const selectedCategories = categories
      ? decodeURIComponent(categories).split(',')
      : []
    const selectedBrands = brands ? decodeURIComponent(brands).split(',') : []
    const selectedTerms = [...selectedCategories, ...selectedBrands]

    Array.from(this.form.elements).forEach(checkbox => {
      selectedTerms.forEach(termID => {
        if (checkbox.value === `term-${termID}`) {
          checkbox.checked = true
        }
      })
    })
  }

  handleChange(e) {
    e.preventDefault()
    const { innerWidth } = window
    if (innerWidth >= 992) {
      const url = this.getUrl()
      window.history.pushState(null, null, url)
      window.dispatchEvent(new CustomEvent('history-update'))
    }
  }

  async handleHistory() {
    this.wrapper.classList.add('fetching')
    const url = this.getUrl()
    return this.navigate(url)
  }

  getUrl() {
    const { origin, pathname, search } = window.location
    const url = `${origin}${this.path || pathname}`
    const urlParams = new URLSearchParams(search)

    const categories = Array.from(this.form.elements)
      .filter(checkbox => checkbox.name === 'categories[]' && checkbox.checked)
      .map(checkbox => checkbox.value.replace('term-', ''))

    const brands = Array.from(this.form.elements)
      .filter(checkbox => checkbox.name === 'brands[]' && checkbox.checked)
      .map(checkbox => checkbox.value.replace('term-', ''))

    if (categories.length) {
      urlParams.set('categorias', encodeURIComponent(categories.join(',')))
    } else if (urlParams.has('categorias')) {
      urlParams.delete('categorias')
    }

    if (brands.length) {
      urlParams.set('marcas', encodeURIComponent(brands.join(',')))
    } else if (urlParams.has('marcas')) {
      urlParams.delete('marcas')
    }

    const params = urlParams.toString()

    return params ? `${url}?${urlParams.toString()}` : url
  }

  handleSubmit(e) {
    e.preventDefault()
    const url = this.getUrl()
    return this.navigate(url)
  }

  navigate(url) {
    this.currentUrl = url
    window.location.href = url
  }

  initToggle() {
    this.groups.forEach(group => {
      const toggle = group.querySelector('.shop-filters__group__title')
      if (toggle) {
        toggle.addEventListener('click', () => {
          group.classList.toggle('shop-filters__group--active')
        })
      }
    })
  }

  init() {
    this.getCheckedStatus()
    this.form.addEventListener('submit', this.handleSubmit)

    Array.from(this.options).forEach(input => {
      input.addEventListener('input', this.handleChange)
    })

    window.onpopstate = () => {
      window.dispatchEvent(new CustomEvent('history-update'))
    }

    window.addEventListener(
      'history-update',
      debounce(1000, this.handleHistory)
    )

    if (this.resetBtn) {
      this.resetBtn.addEventListener('click', this.resetForm)
    }
  }
}

const shopFiltersInit = {
  init() {
    const elements = document.querySelectorAll('.shop-filters')
    Array.from(elements).map(element => new ShopFilters(element))
  },
}

export default shopFiltersInit
